package pl.decks.personal.components.animations

import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.silk.style.animation.Keyframes
import org.jetbrains.compose.web.css.percent

object FlickerAnimation {
    object Vars {
        val fromOpacity by StyleVariable<Number>(1)
        val toOpacity by StyleVariable<Number>(0)
    }

    val Frames = Keyframes {
        from { Modifier.opacity(Vars.fromOpacity.value()) }
        50.percent { Modifier.opacity(Vars.toOpacity.value()) }
        to { Modifier.opacity(Vars.fromOpacity.value()) }
    }
}
